import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme, { layout } from '../../theme.style';

export default mergeStyleSets({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: pxToRem(16),
    padding: '1rem 1.5rem 1rem 0',
    fontWeight: 'bold',
    cursor: 'pointer',
    selectors: {
      [layout.breakpoints.min.md]: {
        marginLeft: pxToRem(24),
      },
    },
  },
  icon: {
    height: pxToRem(16),
    marginLeft: pxToRem(16),
    color: theme.palette.themePrimary,
    cursor: 'pointer',
    selectors: {
      '&:hover': {
        color: theme.palette.themePrimary,
      },
    },
  },
  isOpen: {
    paddingBottom: pxToRem(16),
    borderBottom: `${pxToRem(2)} solid ${theme.palette.neutralQuaternary}`,
  },
});
